module.exports = __webpack_public_path__ + "img/nutrition1.6934b5e0.png";